module.exports = __webpack_public_path__ + "static/forest-9bbf8eea076fc49fc7982cb128a736f2.jpg";